import { apiHelper } from '@/utils/newRequestHelpers';

export default {
  exportStaffSchedule(params) {
    return apiHelper.get('/v1/schedule/export/staff-working-time', { params });
  }
};
